import React from 'react';

import { useRouter } from 'next/router';

import { Locale } from '../Intl/types';
import { getRouteByPathname } from '../Routing/routes';

import { PageContext } from './PageContext';
import { PageContextValue, PageProps, TargetPageProps } from './types';

export const PageProvider = ({
  children,
  pageProps,
  locale,
}: {
  children: React.ReactNode;
  pageProps: PageProps;
  locale: Locale;
}) => {
  const router = useRouter();

  const value: PageContextValue = React.useMemo(() => {
    const route = getRouteByPathname(router.pathname);

    const switchLanguageURL = route
      ? route.getSwitchLanguageURL(router.query, locale)
      : null;

    return {
      traceID: pageProps.traceID,
      switchLanguageURL,
      getRequiredTargetPageProps: <T extends TargetPageProps>() => {
        if (pageProps.targetPageProps == null) {
          throw new Error('Attepmt to access empty TargetPageProps');
        }

        return pageProps.targetPageProps as T;
      },
    };
  }, [
    locale,
    pageProps.targetPageProps,
    pageProps.traceID,
    router.pathname,
    router.query,
  ]);

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};
